// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IsEmailRegisteredRequestModel {
    static getAttributeTypeMap() {
        return IsEmailRegisteredRequestModel.attributeTypeMap;
    }
}
IsEmailRegisteredRequestModel.discriminator = undefined;
IsEmailRegisteredRequestModel.additionalProperties = false;
IsEmailRegisteredRequestModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
];
//# sourceMappingURL=isEmailRegisteredRequestModel.js.map